import React from 'react';
import { Accordion, Table, Badge } from 'react-bootstrap';
import { FaDatabase } from "react-icons/fa";

const DataTable = ({ chartData, timeRangeType }) => (
  <Accordion className="mt-4">
    <Accordion.Item eventKey="0">
      <Accordion.Header>
        <FaDatabase className="me-2" />
        View {timeRangeType === 'today' ? 'raw' : 'aggregated'} matrix data
      </Accordion.Header>
      <Accordion.Body>
        <div className="table-responsive">
          <Table striped hover size="sm">
            <thead>
              <tr>
                <th>So. no.</th>
                <th>Time Range</th>
                <th>Display Time</th>
                <th>Aggregation</th>
                <th>Respiratory Rate</th>
                <th>Heart Rate</th>
                <th>Active Energy</th>
                <th>HRV</th>
                <th>Data Points</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {chartData.map((batch, index) => (
                <tr key={index} className={batch.isEmptyData ? 'table-warning' : ''}>
                  <td>{index+1}</td>
                  <td className="text-nowrap">{batch.timeRange}</td>
                  <td className="text-nowrap">{batch.displayTime}</td>
                  <td>
                    <Badge bg={batch.isEmptyData ? "warning" : "info"}>
                      {batch.aggregation}
                    </Badge>
                  </td>
                  <td>{batch.respiratory_rate ? `${batch.respiratory_rate.toFixed(1)} bpm` : '-'}</td>
                  <td>{batch.heart_rate ? `${batch.heart_rate.toFixed(0)} bpm` : '-'}</td>
                  <td>{batch.active_energy ? `${batch.active_energy.toFixed(1)} kcal` : '-'}</td>
                  <td>{batch.hrv ? `${batch.hrv.toFixed(1)} ms` : '-'}</td>
                  <td className="text-nowrap">
                    {batch.dataPoints?.respiratory || 0 > 0 ? 
                      `R:${batch.dataPoints?.respiratory || 0} H:${batch.dataPoints?.heart || 0}` : 
                      'No data'}
                  </td>
                  <td>
                    {batch.isEmptyData ? (
                      <Badge bg="warning">No Data</Badge>
                    ) : batch.isDailyAggregate ? (
                      <Badge bg="success">Aggregated</Badge>
                    ) : (
                      <Badge bg="info">Raw</Badge>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>
);

export default DataTable;